import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'catalogs/components/list/CatalogsActions';

const CatalogsListRow = ({ catalog, company, subcompany, permissions, t, handleToggle, root }) => {
  return (
    <tr>
      <td>{t(catalog.name)}</td>
      <td className="text-center">{t(catalog.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          root={root}
          catalog={catalog}
          company={company}
          subcompany={subcompany}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(CatalogsListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/CatalogsListRow.js